var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item list-group-item-action d-flex justify-content-between",class:{ active: _vm.todo.done },on:{"click":function($event){_vm.toggle(_vm.todo)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.todo.text)}}),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.remove(_vm.todo)}}},[_vm._v("X")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-947332ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TodoItem.vue
// module id = 23
// module chunks = 2